



















import {Component, Vue} from 'vue-property-decorator';
import {trimText} from '@/util';

@Component
export default class ChatActionForm extends Vue {
  public text: string = ''

  get isDisabled(): boolean {
    return !this.text
  }

  public keyDownEnter(e: any) {
    e.preventDefault() // 改行を無効化
    this.send()
  }

  public keyUpEnter(e: any) {
    e.preventDefault()
  }

  public async send() {
    if (this.text) {
      const text = trimText(this.text)
      this.$emit('send', text)
      this.clearText()
    }
  }

  public clearText() {
    this.text = ''
  }
}
